import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';
import {
    setAction as setUpcomingAppointments,
    reinitAction
} from 'one-state-upcoming-appointments';
import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton,
} from 'one-model-local';

import {
    RESET,
    SET as patientSET,
} from 'one-state-subject/src/types';


export const enum Types {
    SETAPPOINTMENTS = 'set-appointments/set',
    SETUPCOMINGAPPTS = 'one-state-upcoming-appointments/set',
}

const pushtoUpcomingAppts = (payload: any) => setUpcomingAppointments(payload);
const pushToSkeleton = (payload: any) => setSkeletonAction(payload);


/**
 * This Function is used to fetch upcoming appointments
 * @param context contains settings json etc ..
 */
export const pushUpcomingApptsEpic = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.SETAPPOINTMENTS),
            mergeMap((action: any) => {
                /**
                 * @param dataresposne contains the patientlookup response
                 */
                let dataresponse = action.payload;
                log.debug("one-epics", "fetch Upcoming Appointments request", dataresponse);
                if (dataresponse) {
                    const getRequest = (datares: any) => {
                        let result = TransformResponse(datares, context);
                        log.debug("one-epics", "fetch Upcoming Appointments response", result);
                        return from([result]);
                    }
                    return getRequest(dataresponse).
                        pipe(
                            map((response: any) => pushtoUpcomingAppts(response))
                        )
                }
            })

        )
    }
);

/**
 * This Fuction will clear data of upcoming appointments epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearUpcomingApptEpic = (context: any) => (
    (action$: any) => {
        const { log} = context;
        log.debug(
            "ccw-gadget,upcomingappointments-epic",
            "Reset-Appointments-epic", {
            });
        return action$.pipe(
            ofType(patientSET, RESET),
            map(action => reinitAction())
        )
    }
);
/**
 * This Function is used to reset the upcoming appointments skeleton
 * @param context conatins settings json etc
 */
export const skeletonUpcomingApptsReset = (context: any) => (
    (action$: ActionsObservable<any>) => {
        let skeletonupcomingappts: Skeleton = {
            upcomingAppts_skeleton: false
        }
        return action$.pipe(
            ofType(Types.SETUPCOMINGAPPTS),
            map(action => pushToSkeleton(skeletonupcomingappts)),
        )
    }
);
